import * as React from 'react';
import propz from 'propz';
import { FunctionComponent } from 'react';
import { SPORT_GENDER_SERVER_TO_CLIENT_MAPPING, YES_NO_OPTIONS } from '../../consts/common';
import { formatTeamAgesCompact, resolveAgeNamingFromContext } from '../../helpers/ageGroups';
import './SchoolTeamSummary.css';

interface Props {
  team: any;
  user: any;
}

const ROWS = [
  { title: 'Name', field: 'name' },
  { title: 'Sports', field: 'sportName' },
  { title: 'Season', field: 'season' },
  { title: 'Description ', field: 'description' },
  { title: 'Age', field: 'ages' },
  { title: 'Gender', field: 'gender' }
];

export const SchoolTeamSummary: FunctionComponent<Props> = props => {
  const rows = ROWS.map((row, index) => {
    let contentCell: string;
    const field = row.field;

    const { team } = props;

    switch (field) {
      case 'name':
        contentCell = propz.get(team, ['name'], '');
        break;
      case 'sportName':
        contentCell = propz.get(team, ['sports'], []).map(sport => sport.name).join(', ') || propz.get(team, ['sport', 'name'], '');
        break;
      case 'season':
        contentCell = propz.get(team, ['season'], '');
        break;
      case 'description':
        contentCell = propz.get(team, ['description'], '');
        break;
      case 'ages':
        contentCell = formatTeamAgesCompact(team.ages || [], resolveAgeNamingFromContext(props.user));
        break;
      case 'gender':
        contentCell = SPORT_GENDER_SERVER_TO_CLIENT_MAPPING[team.gender];
        break;
      default:
        contentCell = team[row.field];
    }

    return (
      <div className="teamSummary__row" key={`team_summary_${index}`}>
        <span>{row.title.trim()}</span>
        <strong>{contentCell || '—'}</strong>
      </div>
    );
  });

  return <div className="teamSummary">{rows}</div>;
};

SchoolTeamSummary.displayName = 'SchoolTeamSummary';
